/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { ApolloCustomerErrorAlert } from '@graphcommerce/magento-customer/components/ApolloCustomerError/ApolloCustomerErrorAlert'
import { Form, MessageSnackbar } from '@graphcommerce/next-ui'
import { useFormGqlMutation } from '@graphcommerce/react-hook-form'
import { Trans } from '@lingui/react'
import { MenuItem, Paper, Switch } from '@mui/material'
import { StandardButton } from '../../Button/ButtonStyles'
import { StandardDropdown } from '../../Dropdown/StandardDropdown'
import { StandardTextField } from '../../TextInput/TextFieldStyles'
import { NameFields } from '../NameFields/NameFields'
import { UpdateCustomerNameDocument } from './UpdateCustomerName.gql'

type ChangeNameFormProps = {
  prefix?: string
  firstname: string
  lastname: string
  companyName?: string
  companyIndustry?: string
  allowRemoteShoppingAssistance?: boolean
}

export function ChangeNameForm(props: ChangeNameFormProps) {
  const {
    prefix,
    firstname,
    lastname,
    companyName,
    companyIndustry,
    allowRemoteShoppingAssistance,
  } = props
  const form = useFormGqlMutation(
    UpdateCustomerNameDocument,
    {
      defaultValues: {
        prefix: prefix ?? '',
        firstname: firstname ?? '',
        lastname: lastname ?? '',
        companyName: companyName ?? '',
        companyIndustry: companyIndustry ?? '',
        allowRemoteShoppingAssistance: allowRemoteShoppingAssistance ?? false,
      },
    },
    { errorPolicy: 'all' },
  )

  const { handleSubmit, error, formState, register, watch } = form
  const submit = handleSubmit(() => {})
  const industryTypeOptions = [
    { value: 'retail', label: 'Retail' },
    { value: 'ecommerce', label: 'Ecommerce' },
    { value: 'cafe_bakery', label: 'Cafe / Bakery' },
    { value: 'bar_restaurant', label: 'Bar + Restaurant' },
    { value: 'hotel_resort', label: 'Hotel / Resort' },
    { value: 'fast_casual_restaurant', label: 'Fast Casual Restaurant' },
    { value: 'dispensery', label: 'Dispensery' },
    { value: 'brewery_winery', label: 'Brewery / Winery' },
    { value: 'creative_agency', label: 'Creative Agency' },
  ]

  const menuItems = industryTypeOptions.map((option) => (
    <MenuItem value={option.value}>{option.label}</MenuItem>
  ))

  return (
    <>
      <Form onSubmit={submit} noValidate className='mb-10 mt-0 py-0'>
        <Paper elevation={3} className='md:px-15 p-10 md:py-8'>
          <span className='Type-XXL-Regular w-full '>Account details</span>
          <hr className='mb-7 mt-2 text-20-grey' />
          <div className='flex flex-col items-center justify-center gap-x-5 gap-y-5 md:items-start'>
            <div className='flex flex-col items-center gap-x-5 gap-y-5 md:flex-row'>
              <StandardTextField
                label={<Trans id='Company Name' />}
                variant='outlined'
                error={!!formState.errors.firstname}
                color='primary'
                required
                {...register('companyName', {
                  required: true,
                })}
                className='min-w-[260px] outline-material-ui-blue'
                size='small'
                sx={{
                  width: '260px',
                  minWidth: '260px',
                }}
              />

              <StandardDropdown
                value={watch('companyIndustry')?.toString() || ''}
                className='w-[260px] max-w-[260px]'
                {...register('companyIndustry')}
                onChange={(option) => {
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  if (option?.target?.value)
                    form.setValue('companyIndustry', option?.target?.value?.toString())
                }}
                label='Industry Type'
                options={menuItems}
                sx={{
                  width: '260px',
                  minWidth: '260px',
                }}
              />
              {/* <Dropdown
                selectProps={{ name: 'companyIndustry' }}
                label={i18n._('Industry type')}
                className='mt-[15px] w-[260px] max-w-[260px]'
                value={watch('companyIndustry')?.toString() || ''}
                {...register('companyIndustry')}
                optionLabelCountInMainArea={1}
                onChange={(option) => {
                  if (option.value) form.setValue('companyIndustry', option.value.toString())
                }}
                options={[
                  { value: 'retail', label: 'Retail' },
                  { value: 'ecommerce', label: 'Ecommerce' },
                  { value: 'cafe_bakery', label: 'Cafe / Bakery' },
                  { value: 'bar_restaurant', label: 'Bar + Restaurant' },
                  { value: 'hotel_resort', label: 'Hotel / Resort' },
                  { value: 'fast_casual_restaurant', label: 'Fast Casual Restaurant' },
                  { value: 'dispensery', label: 'Dispensery' },
                  { value: 'brewery_winery', label: 'Brewery / Winery' },
                  { value: 'creative_agency', label: 'Creative Agency' },
                ]}
              /> */}
            </div>
            <NameFields
              form={form}
              prefix
              noPadding
              className='items-center justify-center md:justify-start'
            />
            <div>
              <Switch
                checked={watch('allowRemoteShoppingAssistance') || false}
                {...register('allowRemoteShoppingAssistance')}
              />
              <span className='Type-Large-Medium'>
                <Trans id='Allow remote shopping assistance' />
              </span>
            </div>
          </div>
          <div className='mt-11 flex w-full flex-col items-center justify-center gap-[30px] md:flex-row md:justify-start'>
            <StandardButton
              type='submit'
              className='w-full max-w-[284px] bg-material-ui-blue uppercase md:w-auto'
              variant='contained'
              loading={formState.isSubmitting}
            >
              <Trans id='Save' />
            </StandardButton>
          </div>
          <ApolloCustomerErrorAlert error={error} />
        </Paper>
      </Form>
      <MessageSnackbar open={formState.isSubmitSuccessful && !error} variant='pill'>
        <Trans id='Successfully saved changes' />
      </MessageSnackbar>
    </>
  )
}
